module.exports = __webpack_public_path__ + "static/media/HolyCrossNewsletterDecember2024.82e64479.pdf";